import { FEATURE_ONEPORTAL } from '../../constants';
import { SupportDialogOnePortal } from './SupportDialogOneportal';
import { SupportDialogProbonio } from './SupportDialogProbonio';
/**
 * To make the oneportal switch easier and since both dialogs are quite different,
 * both are implemented in their own files. So after the switch, SupportDialogProbonio may just be removed completely.
 */
export const SupportDialog = FEATURE_ONEPORTAL ? SupportDialogOnePortal : SupportDialogProbonio;
